import './MapPin.css';

export default function MapPin({ marker }) {
    const gettable_flags = (alarm, classx, isonlin) => {
        if (alarm !== "") {
            return <span className={'border-black me-1 dashboard-tagalarm2 ' + classx} >{alarm}</span>
        }
        if (isonlin !== undefined) {
            return <span className='border-black me-1 dashboard-tagalarm2 normal'  >ONLINE</span>
        }
        return null
    }

    return (
        <div className='map-pin-wrapper' style={{
            left: marker.pos_x,
            top: marker.pos_y
        }}>
            <div
                className={'map-pin1 ' + marker.alert_class}
                style={{
                    backgroundColor: marker.color,
                }}
            >
            </div>
            <div className='map-tooltip '>
                <h6 style={{ color: marker.color }}>{marker.sitecode_text} {marker.business} Business</h6>
                <h6>{marker.sitename_th}</h6>
                <h6>{marker.siteaddress_sm}</h6>
                <div className='mt-2'>
                    {gettable_flags(marker.count_offline, "alarming", true)} {gettable_flags(marker.count_alarm, "alarming")} {gettable_flags(marker.count_warning, "warning")}
                </div>
                <div className='tooltip-table'>
                    <div className='tooltip-row'>
                        <div className='tooltip-cell'>Capacity</div>
                        <div className='tooltip-cell value-right'>{marker.capacity}</div>
                        <div className='tooltip-cell units'>kWp</div>
                    </div>
                    <div className='tooltip-row'>
                        <div className='tooltip-cell'>Today</div>
                        <div className='tooltip-cell value-right'>{marker.today}</div>
                        <div className='tooltip-cell units'>kWh</div>
                    </div>
                    <div className='tooltip-row'>
                        <div className='tooltip-cell'>Energy (COD)</div>
                        <div className='tooltip-cell value-right'>{marker.energy_cod}</div>
                        <div className='tooltip-cell units'>GWh</div>
                    </div>
                    <div className='tooltip-row'>
                        <div className='tooltip-cell'>Area</div>
                        <div className='tooltip-cell value-right'>{marker.area}</div>
                        <div className='tooltip-cell units'>m<sup>2</sup></div>
                    </div>
                </div>
            </div>
        </div>
    )
}